type SectionProps = {
  children?: React.ReactNode;
  className?: string;
  id?: string;
};

const Section = ({ children, className, id }: SectionProps) => {
  return (
    <section
      className={`section ${className ? className : ''}`}
      id={id}
    >
      {children}
    </section>
  );
};

export { Section };
